// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"124":"d8d3ddd4","148":"cd686ed7","193":"73e8522d","200":"651450bd","487":"03bb23b3","488":"4c737b70","748":"7485cb2e","890":"c2c79068","964":"bbd2969b","969":"66765039"}[chunkId] + ".chunk.js";
};